var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FormAsyncselect", {
    attrs: {
      closeOnSelect: "",
      value: _vm.value,
      pillsColor: _vm.pillsColor,
      customMultiStyle: _vm.customMultiStyleParent,
      options: _vm.optionsList,
      noOptionsText: _vm.noOptionsText,
      placeholder: _vm.placeholder,
      multiple: _vm.multiple,
      invalid: _vm.invalid,
      "select-label": _vm.selectLabel,
      "deselect-label": _vm.deselectLabel,
      showNoResults: _vm.noResults,
      loading: _vm.isLoading,
      searchable: _vm.searchable,
      max: _vm.max,
      trackBy: _vm.trackBy,
      disabled: _vm.disabled,
      "group-label": _vm.groupLabel,
      "group-values": _vm.groupValues,
      "group-select": _vm.groupSelect,
      cref: _vm.cref,
    },
    on: {
      input: _vm.handleInput,
      search: _vm.handleSearch,
      close: function ($event) {
        return _vm.$emit("close")
      },
      setRef: _vm.onSetRef,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "option",
          fn: function ({ option }) {
            return [_vm._t("option", null, { option: option })]
          },
        },
        {
          key: "singleLabel",
          fn: function ({ option }) {
            return [_vm._t("singleLabel", null, { option: option })]
          },
        },
        {
          key: "tag",
          fn: function ({ option, remove }) {
            return [_vm._t("tag", null, { option: option, remove: remove })]
          },
        },
        {
          key: "noResult",
          fn: function () {
            return [_vm._t("noResult")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }